import {Injectable, Inject} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {StoreService} from '../store/store.service';

@Injectable()
export class AutoRefreshService {

    autoRefreshCounter: Observable<number>;
    autoRefreshSubscription: Subscription;

    constructor(@Inject(StoreService) private store: StoreService) {
    }

    setAutoRefresh(interval) {

        const self = this;

        if (self.autoRefreshSubscription != null) {
            self.autoRefreshSubscription.unsubscribe();
            self.autoRefreshCounter = null;
        }

        if (interval != null) {

            self.autoRefreshCounter = Observable.interval(interval);
            self.autoRefreshSubscription = self.autoRefreshCounter.subscribe(function (value) {
                self.store.update('autoRefresh', value);

                console.log('\n');
                console.log('Updated store autoRefresh to = ', value, ' after ', (interval / 1000), ' seconds');
            });

            console.log('\n');
            console.log('====================');
            console.log('Starting new autoRefresh at ', (interval / 1000), ' seconds');
            console.log('====================');
            console.log('\n');
        } else {

            console.log('\n');
            console.log('====================');
            console.log('>>>>>>> Stopped autoRefresh!');
            console.log('====================');
            console.log('\n');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/auto-refresh/auto-refresh.service.ts